import { t } from '@gem/modules/i18n';

import { GOOGLE_MAP_KEY } from 'APP/constants';
import { PayloadType } from 'APP/model/message/messageModel.types';

import { Payload } from '../Payload';

export class LocationPayload extends Payload {
  latitude;
  longitude;

  constructor(data) {
    super({ ...data, payloadType: PayloadType.Location });

    this.latitude = data.latitude;
    this.longitude = data.longitude;
  }

  toJSON() {
    return {
      ...super.toJSON(),
      latitude: this.latitude,
      longitude: this.longitude,
    };
  }

  get text() {
    return t('message_desctription_location');
  }

  get originUrl() {
    const link = `https://www.google.com/maps/search/?api=1&query=${this.latitude},${this.longitude}`;

    return link;
  }

  get url() {
    return `https://maps.googleapis.com/maps/api/staticmap?center=${this.latitude},${this.longitude}&maptype=roadmap&zoom=10&style=feature:all|element:labels|visibility:off&key=${GOOGLE_MAP_KEY}`;
  }

  get typeDescription() {
    return t('message_desctription_location');
  }
}
